import { QUERIES } from '@repo/ui/queries';
import styled from 'styled-components';

import { FlexColumn } from 'styles/layouts';

export const TextContainer = styled(FlexColumn)<{ itemCount: number }>`
  flex: 0 0 100%;
  padding: 0 24px;
  margin-bottom: 24px;
  gap: 12px;

  ${QUERIES.tabletAndUp} {
    flex: 0 0 ${({ itemCount }) => (itemCount <= 2 ? 100 / itemCount : 50)}%;
  }

  ${QUERIES.largeTabletAndUp} {
    flex: 0 0 ${({ itemCount }) => (itemCount <= 3 ? 100 / itemCount : 25)}%;
  }
`;
